import { Component } from '@gondel/core';

import {
	SearchableOveriewComponent,
	ISearchableOverviewSelectors,
	ISearchableOverviewStates,
} from '../../../../shared/utils/js/searchable-overview';
/**
 * news-archive module implementation.
 * @author Srdan Turudic <srdan.turudic@namics.com>
 */

@Component('NewsArchive')
export class NewsArchive extends SearchableOveriewComponent {
	public start() {
		const selectors: ISearchableOverviewSelectors = {
			Button: '.js-cms-news-archive__load-more',
			ButtonContainer: '.cms-news-archive__button',
			StoriesContainer: '.js-cms-news-archive__stories',
			SearchInput: '.m-search-input',
		};

		const states: ISearchableOverviewStates = {
			ButtonInvisible: 'state-cms-news-archive__button--invisible',
		};

		super.start(selectors, states, ['col-12', 'col-md-6', 'col-lg-4', 'cms-news-archive__teaser']);
	}
}
